var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-inbox",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.197,14.18c0.995,-0 1.802,0.804 1.802,1.796c0,0 0,3.526 0,3.526c0,1.382 -1.124,2.502 -2.51,2.502l-16.98,-0c-1.386,-0 -2.51,-1.12 -2.51,-2.502c0,-0 0,-4.231 0,-4.231c0,-0.603 0.491,-1.091 1.095,-1.091c0,-0 4.953,-0 4.953,-0c0.281,-0 0.537,0.157 0.663,0.408l1.122,2.236c0.054,0.108 0.165,0.176 0.286,0.176l5.762,0c0.121,0 0.232,-0.068 0.286,-0.176l1.123,-2.236c0.125,-0.251 0.382,-0.408 0.663,-0.408c-0,-0 4.245,-0 4.245,-0Zm0.319,5.322l0,-3.526c0,-0.176 -0.143,-0.318 -0.319,-0.318c-0,-0 -3.589,-0 -3.589,-0c-0.121,-0 -0.232,0.068 -0.286,0.176l-1.122,2.235c-0.126,0.251 -0.382,0.409 -0.663,0.409l-7.075,0c-0.281,0 -0.538,-0.158 -0.663,-0.409l-1.123,-2.235c-0.054,-0.108 -0.164,-0.176 -0.286,-0.176c0,-0 -3.588,-0 -3.588,-0c-0.177,-0 -0.32,0.142 -0.32,0.318c0,0 0,3.526 0,3.526c0,0.564 0.461,1.024 1.027,1.024l16.98,-0c0.566,-0 1.027,-0.46 1.027,-1.024Zm-8.966,-6.568c-0.035,0.035 -0.226,0.228 -0.551,0.228c-0.313,-0 -0.551,-0.228 -0.551,-0.228l-3.149,-3.139c-0.14,-0.14 -0.227,-0.334 -0.227,-0.548c-0,-0.428 0.348,-0.775 0.777,-0.775c0.215,0 0.409,0.087 0.55,0.227l1.76,1.754c0.01,0.011 0.026,0.014 0.04,0.008c0.014,-0.006 0.023,-0.019 0.023,-0.034l-0,-7.657c-0,-0.428 0.348,-0.775 0.777,-0.775c0.43,0 0.778,0.347 0.778,0.775c-0,0 -0,7.657 -0,7.657c-0,0.015 0.009,0.028 0.023,0.034c0.013,0.006 0.029,0.003 0.04,-0.008l1.759,-1.754c0.141,-0.14 0.336,-0.227 0.55,-0.227c0.43,0 0.778,0.347 0.778,0.775c-0,0.214 -0.087,0.408 -0.228,0.548l-3.149,3.139Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRInbox);
export default __webpack_public_path__ + "static/media/iconR-inbox.c761dbb9fdf6ac9103d1872229e3f0c9.svg";
export { ForwardRef as ReactComponent };